module.exports = __webpack_public_path__ + "img/logo.ede95eb3.svg";